import React, { Component } from 'react';
import { Form } from 'antd';

import { RangeType } from '../range-type/range-type'
import { PermissionArea } from '../permission-area/permission-area'

export class AccountRange extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: [],
        }
    }

    render() {
        const { typeOption, editable } = this.props;
        return <>
            <Form.Item
                className="notRequired checkbox-style"
                name='permission_area'
                label='* Khu vực::'
                rules={[
                ]}>
                <PermissionArea typeOption={typeOption} editable={editable} />
            </Form.Item>
        </>
    }
}